import React from "react";
import { Grid, Box, Typography, Paper } from "@mui/material";
import { Login } from "../Login";
import { OrunalLogo } from "../../Components/Reusable/OrunalLogo";

export const LoginLandingPage = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        overflow: "hidden",
        background: "#ffffff",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <Grid container sx={{ height: "100vh", width: "100%", overflow: "hidden" }}>
        {/* Left Side - Hero/Marketing Content */}
        <Grid
          item
          xs={12}
          md={7}
          lg={8}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #0176d3 0%, #0159a8 50%, #014a8f 100%)",
            padding: { md: "2rem 2.5rem", lg: "3rem 5rem", xl: "4rem 6rem" },
            position: "relative",
            overflow: "hidden",
            height: "100vh",
          }}
        >
          {/* Animated Decorative Background Elements */}
          <Box
            sx={{
              position: "absolute",
              top: "-15%",
              left: "-5%",
              width: "600px",
              height: "600px",
              borderRadius: "50%",
              background: "rgba(255, 255, 255, 0.12)",
              filter: "blur(100px)",
              animation: "float 20s ease-in-out infinite",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "-20%",
              right: "-10%",
              width: "700px",
              height: "700px",
              borderRadius: "50%",
              background: "rgba(255, 255, 255, 0.08)",
              filter: "blur(120px)",
              animation: "float 25s ease-in-out infinite reverse",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              height: "80%",
              borderRadius: "30px",
              border: "2px solid rgba(255, 255, 255, 0.1)",
              pointerEvents: "none",
              animation: "borderPulse 4s ease-in-out infinite",
            }}
          />
          
          {/* Floating Particles */}
          {[...Array(6)].map((_, i) => (
            <Box
              key={i}
              sx={{
                position: "absolute",
                width: i % 2 === 0 ? "8px" : "6px",
                height: i % 2 === 0 ? "8px" : "6px",
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.4)",
                top: `${15 + i * 15}%`,
                left: `${10 + i * 12}%`,
                animation: `particle ${5 + i * 2}s ease-in-out infinite`,
                animationDelay: `${i * 0.5}s`,
                boxShadow: "0 0 20px rgba(255, 255, 255, 0.5)",
              }}
            />
          ))}

          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              maxWidth: { md: 580, lg: 680 },
              color: "#ffffff",
              textAlign: "left",
              transform: { md: "scale(0.85)", lg: "scale(0.95)", xl: "scale(1)" },
              transformOrigin: "center center",
            }}
          >
            {/* Animated Badge */}
            {/* <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                borderRadius: "50px",
                padding: { md: "4px 10px", lg: "7px 18px", xl: "8px 20px" },
                marginBottom: { md: 0.8, lg: 2.2, xl: 3 },
                border: "1px solid rgba(255, 255, 255, 0.3)",
                animation: "slideInLeft 0.8s ease-out",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.25)",
                  transform: "translateX(5px)",
                  boxShadow: "0 6px 30px rgba(0, 0, 0, 0.15)",
                },
              }}
            >
              <Box
                sx={{
                  width: { md: 6, lg: 7, xl: 8 },
                  height: { md: 6, lg: 7, xl: 8 },
                  borderRadius: "50%",
                  backgroundColor: "#4ade80",
                  marginRight: 1,
                  animation: "pulse 2s ease-in-out infinite",
                  boxShadow: "0 0 10px #4ade80",
                }}
              />
              <Typography sx={{ fontSize: { md: "0.75rem", lg: "0.85rem", xl: "0.9rem" }, fontWeight: 500 }}>
                🏆 Trusted by 10,000+ businesses worldwide
              </Typography>
            </Box> */}

            {/* Main Headline */}
            <Typography
              sx={{
                fontSize: { md: "2.2rem", lg: "2.75rem", xl: "3.5rem" },
                fontWeight: 800,
                lineHeight: 1.15,
                marginBottom: { md: 1.2, lg: 2.2, xl: 3 },
                textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)",
                background: "linear-gradient(135deg, #ffffff 0%, #e0f2fe 50%, #ffffff 100%)",
                backgroundSize: "200% auto",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                animation: "slideInLeft 1s ease-out 0.2s both, shimmer 3s linear infinite",
              }}
            >
              Your Central Hub for Team Success
            </Typography>

            {/* Subheadline */}
            <Typography
              sx={{
                fontSize: { md: "1.05rem", lg: "1.15rem", xl: "1.35rem" },
                fontWeight: 400,
                lineHeight: 1.4,
                marginBottom: { md: 1.8, lg: 3.5, xl: 5 },
                animation: "fadeInUp 1s ease-out 0.4s both",
                opacity: 0.9,
                maxWidth: { md: 520, lg: 600 },
              }}
            >
              Empower your team with powerful tools for task management, real-time collaboration, and data-driven insights—all in one seamless platform.
            </Typography>

            {/* Feature Cards */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: { md: 1.8, lg: 2.2, xl: 2.5 },
                marginBottom: { md: 1.8, lg: 3.5, xl: 5 },
              }}
            >
              {[
                { icon: "👥", title: "Smart Staff Management", desc: "Automate HR tasks & empower teams" },
                { icon: "💎", title: "Intelligent CRM", desc: "Convert leads into loyal customers" },
                { icon: "🚀", title: "Marketing Automation", desc: "Scale campaigns effortlessly" },
                { icon: "🔒", title: "Enterprise Security", desc: "Bank-grade data protection" },
              ].map((feature, index) => (
                <Box
                  key={index}
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    padding: { md: 1.5, lg: 2.2, xl: 2.5 },
                    borderRadius: "16px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    animation: `fadeInUp 0.6s ease-out ${0.6 + index * 0.1}s both`,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      transform: "translateY(-8px) scale(1.02)",
                      boxShadow: "0 16px 40px rgba(0, 0, 0, 0.25)",
                      borderColor: "rgba(255, 255, 255, 0.4)",
                      "& .feature-icon": {
                        transform: "scale(1.2) rotate(5deg)",
                      },
                    },
                  }}
                >
                  <Typography 
                    className="feature-icon"
                    sx={{ 
                      fontSize: { md: "1.8rem", lg: "2.3rem", xl: "2.5rem" }, 
                      marginBottom: { md: 0.4, lg: 0.8, xl: 1 },
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      display: "inline-block",
                    }}
                  >
                    {feature.icon}
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: { md: "0.88rem", lg: "1rem", xl: "1.05rem" }, marginBottom: { md: 0.3, lg: 0.5 } }}>
                    {feature.title}
                  </Typography>
                  
                  <Typography sx={{ opacity: 0.85, fontSize: { md: "0.75rem", lg: "0.85rem", xl: "0.875rem" }, lineHeight: { md: 1.4, lg: 1.5 } }}>
                    {feature.desc}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Stats Section */}
            <Box
              sx={{
                display: "flex",
                gap: { md: 2.5, lg: 4, xl: 6 },
                padding: { md: 1.5, lg: 2.5, xl: 3 },
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "18px",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                animation: "fadeInUp 1s ease-out 1s both",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 40px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              {[
                { number: "10K+", label: "Active Businesses" },
                { number: "99.9%", label: "Uptime Guarantee" },
                { number: "10x", label: "Productivity Boost" },
              ].map((stat, index) => (
                <Box key={index}>
                  <Typography
                    sx={{
                      fontWeight: 800,
                      marginBottom: 0.3,
                      fontSize: { md: "1.5rem", lg: "2rem", xl: "2.5rem" },
                      background: "linear-gradient(to right, #ffffff, #bfdbfe)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    {stat.number}
                  </Typography>
                  <Typography
                    sx={{
                      opacity: 0.85,
                      fontSize: { md: "0.7rem", lg: "0.8rem", xl: "0.875rem" },
                      fontWeight: 500,
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          
          <style>
            {`
              @keyframes pulse {
                0%, 100% { opacity: 1; transform: scale(1); }
                50% { opacity: 0.8; transform: scale(1.1); }
              }
              
              @keyframes float {
                0%, 100% { transform: translate(0, 0); }
                50% { transform: translate(30px, -30px); }
              }
              
              @keyframes borderPulse {
                0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(1); }
                50% { opacity: 0.5; transform: translate(-50%, -50%) scale(1.02); }
              }
              
              @keyframes particle {
                0%, 100% { transform: translateY(0) translateX(0); opacity: 0.4; }
                25% { transform: translateY(-30px) translateX(15px); opacity: 0.8; }
                50% { transform: translateY(-50px) translateX(0); opacity: 1; }
                75% { transform: translateY(-30px) translateX(-15px); opacity: 0.8; }
              }
              
              @keyframes slideInLeft {
                from {
                  opacity: 0;
                  transform: translateX(-60px);
                }
                to {
                  opacity: 1;
                  transform: translateX(0);
                }
              }
              
              @keyframes fadeInUp {
                from {
                  opacity: 0;
                  transform: translateY(40px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
              
              @keyframes shimmer {
                0% { background-position: -200% center; }
                100% { background-position: 200% center; }
              }
            `}
          </style>
        </Grid>

        {/* Right Side - Login Form */}
        <Grid
          item
          xs={12}
          md={5}
          lg={4}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#ffffff",
            padding: { xs: 2, sm: 3, md: 2.5, lg: 3 },
            overflowY: "auto",
            overflowX: "hidden",
            height: "100vh",
            boxShadow: { md: "-8px 0 40px rgba(0, 0, 0, 0.06)" },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: { xs: 400, sm: 420, md: 400, lg: 440 },
              padding: { xs: 0, sm: 0.5, md: 0 },
              margin: "auto",
            }}
          >
            {/* Logo Section */}
            <Box
              sx={{
                marginBottom: { xs: 1, sm: 1.5, md: 1.2, lg: 2 },
                textAlign: "center",
              }}
            >
              <OrunalLogo spacing={{ xs: 0.5, sm: 1, md: 0.5, lg: 1 }} />
            </Box>
              
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "#1a1a1a",
                marginBottom: 0.25,
                fontSize: { xs: "1.25rem", sm: "1.4rem", md: "1.35rem", lg: "1.6rem" },
                textAlign: "center",
              }}
            >
              Welcome Back! 👋
            </Typography>
            <Typography
              sx={{
                color: "#667085",
                fontSize: { xs: "0.8rem", sm: "0.875rem", md: "0.85rem" },
                textAlign: "center",
                marginBottom: { xs: 1.5, sm: 2, md: 1.8, lg: 2.5 },
              }}
            >
              Sign in to supercharge your business operations
            </Typography>


            {/* Login Component */}
            <Login />
            
            {/* Footer Text */}
            <Box sx={{ marginTop: { xs: 1.5, sm: 2, md: 1.8, lg: 2.5 }, textAlign: "center" }}>
              <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.85rem" }, color: "#98a2b3" }}>
                © 2026 Orunal. All rights reserved.
              </Typography>
            </Box>
            </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginLandingPage;


      
